'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

var DocumentHead = function DocumentHead(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx(Fragment, {
    children: children
  }), document.head);
};

DocumentHead.propTypes = {
  children: PropTypes.node.isRequired
};
export default DocumentHead;